export default __webpack_public_path__ + "static/media/hon.f75e5b41.png";